import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { dateFormat } from '../../../../contstant';
import { Badge } from '../../../../components/Common/UI/Badge';
import { StatusBadge } from '../../../../components/Common/StatusBadge';
import { StatusesType } from '../../../types';
import { MenuPopoverContent, Popover, PopoverTrigger } from '../../../../components/Common/UI/Popover';
import Icons from '../../../../components/Common/Icons/Icons';
import { Button } from '../../../../components/Common/UI/Button';
import { MessageManagerRes, ScheduledDates } from '../Dashboard/data/messageManager';
import UnapproveCompanyDialog from './Modals/Unapprove';
import ModalDelete from '../../Common/Modals/Delete';
import DataTable from '../../../../components/Common/UI/DataTable';
import { campaignCol } from './Modals/columns';
import { notifySuccess } from '../../../../components/Common/UI/Notify';

export const CampaignDialogData = [
  { key: 'ID Number:', value: 39876 },
  { key: 'Start Date:', value: '1 March 2022' },
  { key: 'Application:', value: 'Monthly' },
  { key: 'Description:', value: 'test_009' },
  { key: 'End Date:', value: '1 March 2022' },
];

export const CampaignSaveDialogData = [
  { key: 'ID Number:', value: 39876 },
  { key: 'Start Date:', value: '1 March 2022' },
  { key: 'Description:', value: 'test_009' },
  { key: 'End Date:', value: '1 March 2022' },
  { key: 'Application:', value: 'Monthly' },
];

export const messageManagerCol: ColumnDef<MessageManagerRes>[] = [
  {
    accessorKey: 'id',
    header: 'ID Number',
    enableSorting: true,
    cell: ({ row }) => <Badge variant="counter">{row.getValue('id')}</Badge>,
  },
  {
    enableSorting: true,
    accessorKey: 'campaignName',
    header: 'Campaign Name',
  },
  {
    enableSorting: true,
    accessorKey: 'revDate',
    header: 'Rev Date',
    cell: ({ row }) => dayjs(row.getValue('revDate')).format(dateFormat),
  },
  {
    enableSorting: true,
    accessorKey: 'appType',
    header: 'App Type',
  },
  {
    enableSorting: true,
    accessorKey: 'scheduledDates',
    header: 'Scheduled Date',
    cell: ({ row }) => {
      const dates: ScheduledDates = row.getValue('scheduledDates');

      return (
        <span>
          {dayjs(dates?.from).format(dateFormat)}
          <small className="px-2 text-muted-foreground">to</small>
          {dayjs(dates?.to).format(dateFormat)}
        </span>
      );
    },
  },
  {
    enableSorting: true,
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => <StatusBadge status={row.getValue('status')} />,
    size: 128,
  },
  {
    id: 'actions',
    accessorKey: '',
    header: '',
    cell: ({ row }) => {
      const status: StatusesType = row.getValue('status') || 'draft';

      return (
        <Popover>
          <PopoverTrigger>
            <Icons.More />
          </PopoverTrigger>
          <MenuPopoverContent>
            <ActionsByStatus status={status} campaignId={row.original.id} />
          </MenuPopoverContent>
        </Popover>
      );
    },
    size: 50,
  },
];

interface IActionsByStatus {
  status: StatusesType;
  campaignId: number;
}

export function ActionsByStatus({ status, campaignId }: IActionsByStatus) {
  const navigate = useNavigate();

  if (status === 'draft') {
    return (
      <>
        <Button
          size="auto"
          variant="ghost"
          title="Edit"
          onClick={() => navigate(`/infoTrac/message-manager/builder/${campaignId}`)}
        >
          <Icons.FileEdit />
          Edit
        </Button>
        <Button size="auto" variant="ghost" title="Approve">
          <Icons.Approve />
          Approve
        </Button>
        <Button size="auto" variant="ghost" title="Copy">
          <Icons.FileCopy />
          Copy
        </Button>
        <ModalDelete
          trigger={
            <div className="flex gap-1 font-medium">
              <Icons.Delete />
              Delete
            </div>
          }
          title={
            <div>
              <p className="text-xl leading-none">Delete Campaign</p>
              <p className="text-muted-foreground font-normal text-base">
                Some text info. Deleting of this campaign is permanent...
              </p>
            </div>
          }
          content={
            <>
              <div className="grid grid-cols-3 gap-x-3 mb-[10px]">
                {CampaignDialogData.map(({ key, value }) => (
                  <div className="grid grid-cols-[90px_1fr] gap-[10px]" key={key}>
                    <div className="font-medium">{key}</div>
                    <div className="opacity-60">{value}</div>
                  </div>
                ))}
              </div>
              <DataTable columns={campaignCol} data={[{ id: 0 }]} variant="bordered" />
            </>
          }
          okText="Delete Campaign"
          onOk={() => notifySuccess('Campaign deleted')}
        />
      </>
    );
  }

  if (status === 'scheduled') {
    return (
      <>
        <UnapproveCompanyDialog />
        <Button size="auto" variant="ghost" title="Copy">
          <Icons.FileCopy />
          Copy
        </Button>
        <Button size="auto" variant="ghost" title="View">
          <Icons.EyeFilled />
          View
        </Button>
      </>
    );
  }

  if (status === 'completed') {
    return (
      <>
        <UnapproveCompanyDialog />
        <Button size="auto" variant="ghost" title="Preview">
          <Icons.EyeFilled />
          Preview
        </Button>
        <Button size="auto" variant="ghost" title="Copy">
          <Icons.FileCopy />
          Copy
        </Button>
      </>
    );
  }

  return (
    <>
      <Button size="auto" variant="ghost" title="Copy">
        <Icons.FileCopy />
        Copy
      </Button>
      <Button size="auto" variant="ghost" title="View">
        <Icons.EyeFilled />
        View
      </Button>
    </>
  );
}
